export default function EmptyState({ message }: { message: string }) {
  return (
    <div className="rounded-2xl border border-nav-line bg-card px-4 py-8 text-center text-sm text-text-secondary">
      {message}
    </div>
  )
}
